export const handlePrintCertificate = (transaction) => {
	if (!transaction) return;

	const formatDate = (dateString) => {
		if (!dateString) return 'N/A';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		});
	};

	const cleanDescription = (description) => {
		if (!description) return 'No description available';
		return description
			.replace(/<p><p>/g, '')
			.replace(/<\/p><\/p>/g, '')
			.replace(/<[^>]*>/g, '')
			.trim();
	};

	const certificateHTML = `
            <html>
                <head>
                    <title>Reward Certificate</title>
                    <style>
                        body {
                            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                            margin: 0;
                            padding: 40px;
                            background: white;
                        }
                        .certificate-container {
                            max-width: 800px;
                            margin: 0 auto;
                            border: 3px solid #1890ff;
                            border-radius: 12px;
                            padding: 40px;
                            background: linear-gradient(135deg, #f6f9fc 0%, #ffffff 100%);
                            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
                        }
                        .certificate-header {
                            text-align: center;
                            margin-bottom: 30px;
                            border-bottom: 2px solid #1890ff;
                            padding-bottom: 20px;
                        }
                        .certificate-title {
                            font-size: 32px;
                            font-weight: bold;
                            color: #1890ff;
                            margin: 0;
                            text-transform: uppercase;
                            letter-spacing: 2px;
                        }
                        .certificate-subtitle {
                            font-size: 16px;
                            color: #666;
                            margin: 10px 0 0 0;
                        }
                        .certificate-body {
                            margin: 30px 0;
                        }
                        .reward-image {
                            width: 200px;
                            height: 200px;
                            object-fit: cover;
                            border-radius: 8px;
                            border: 2px solid #f0f0f0;
                            margin: 0 auto;
                            display: block;
                        }
                        .reward-name {
                            font-size: 24px;
                            font-weight: bold;
                            color: #333;
                            text-align: center;
                            margin: 20px 0 10px 0;
                        }
                        .reward-description {
                            font-size: 16px;
                            color: #666;
                            line-height: 1.6;
                            text-align: center;
                            margin-bottom: 30px;
                            padding: 0 20px;
                        }
                        .certificate-details {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 20px;
                            margin: 30px 0;
                        }
                        .detail-item {
                            text-align: center;
                            padding: 15px;
                            background: white;
                            border-radius: 8px;
                            border: 1px solid #f0f0f0;
                        }
                        .detail-label {
                            font-size: 14px;
                            color: #595959;
                            text-transform: uppercase;
                            letter-spacing: 1px;
                            margin-bottom: 5px;
                        }
                        .detail-value {
                            font-size: 18px;
                            font-weight: bold;
                            color: #333;
                        }
                        .certificate-footer {
                            text-align: center;
                            margin-top: 40px;
                            padding-top: 20px;
                            border-top: 1px solid #f0f0f0;
                            color: #595959;
                            font-size: 14px;
                        }
                        @media print {
                            body {
                                padding: 20px;
                            }
                            .certificate-container {
                                box-shadow: none;
                                border: 2px solid #1890ff;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="certificate-container">
                        <div class="certificate-header">
                            <h1 class="certificate-title">Certificate of Achievement</h1>
                            <p class="certificate-subtitle">Reward Redemption Certificate</p>
                        </div>

                        <div class="certificate-body">
                            ${transaction.reward?.image ? `<img src="${transaction.reward.image}" alt="${transaction.reward?.name || 'Reward'}" class="reward-image" />` : ''}

                            <h2 class="reward-name">
                                ${transaction.reward?.name || 'Unknown Reward'}
                            </h2>

                            <div class="reward-description">
                                ${cleanDescription(transaction.reward?.description)}
                            </div>

                            <div class="certificate-details">
                                <div class="detail-item">
                                    <div class="detail-label">Date Claimed</div>
                                    <div class="detail-value">${formatDate(transaction.dateCreated)}</div>
                                </div>
                                <div class="detail-item">
                                    <div class="detail-label">Transaction ID</div>
                                    <div class="detail-value">${transaction.id || 'N/A'}</div>
                                </div>
                            </div>
                        </div>

                        <div class="certificate-footer">
                            <p>This certificate confirms the successful redemption of the above reward.</p>
                            <p>Generated on ${new Date().toLocaleDateString(
															'en-US',
															{
																year: 'numeric',
																month: 'long',
																day: 'numeric',
															}
														)}</p>
                        </div>
                    </div>
                </body>
            </html>
        `;

	const printWindow = window.open('', '_blank');

	printWindow.document.documentElement.innerHTML = certificateHTML;

	// Wait for the document and all images to load before printing
	const images = printWindow.document.querySelectorAll('img');

	if (images.length === 0) {
		printWindow.focus();
		printWindow.print();
		printWindow.close();
		return;
	}

	let loadedImages = 0;
	const totalImages = images.length;

	const checkAllImagesLoaded = () => {
		loadedImages++;
		if (loadedImages === totalImages) {
			printWindow.focus();
			printWindow.print();
			printWindow.close();
		}
	};

	images.forEach((img) => {
		if (img.complete) {
			checkAllImagesLoaded();
		} else {
			img.onload = checkAllImagesLoaded;
			img.onerror = checkAllImagesLoaded;
		}
	});
};
